import(/* webpackMode: "eager", webpackExports: ["RouteChangeListener"] */ "/app/src/app/(shop)/route-change-listener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderClientWrapper"] */ "/app/src/components/_containers/headerClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/footer/footer.tsx");
